// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //LOCAL
  //backendService: 'http://localhost:3000',
  //SANDBOX
  // backendService: 'https://api-herramienta-transporte.sbx.ransaaplicaciones.com'
  //QAS
  // backendService: 'https://api-herramienta-transporte.qas.ransaaplicaciones.com',
  // backendService2: 'https://herramientas-transporte2.qas.ransaaplicaciones.com',
  // //backendService2: 'https://vxhymqlf7b.execute-api.us-east-1.amazonaws.com/qas',
  // tmsService: 'https://api-tms-r360.qas.ransaaplicaciones.com'
  //TEST
  //backendService: 'https://api-herramienta-transporte-tst.sbx.ransaaplicaciones.com'
  //PROD
  backendService: 'https://api-herramienta-transporte.ransaaplicaciones.com',
  backendService2: 'https://herramientas-transporte2.ransaaplicaciones.com',
  tmsService: 'https://api-tms-r360.ransaaplicaciones.com'
};

export const urlDescargaPlantillaPedidos = {
  SBX: 'https://57aufritwyd7gr5io6pq4hyzwi0tjxhf.lambda-url.us-east-1.on.aws/',
  QAS: 'https://e2finiddry3iipd6dp2jblyhbu0hgnee.lambda-url.us-east-1.on.aws/',
  PRD: 'https://cvuzbjwmsn7ubtgeitv42whrgi0vnduq.lambda-url.us-east-1.on.aws/'
}

export const urlCargaPlantillaPedidos = {
  SBX: 'https://d6kg6jozd4bsy6pd3vxiccuymi0vjlwl.lambda-url.us-east-1.on.aws/',
  QAS: 'https://cgbqkwlb2ysrjqp6es27xm2zlu0hxayt.lambda-url.us-east-1.on.aws/',
  PRD: 'https://mamp3i2nstvsnv54mexkxxu46i0ljebe.lambda-url.us-east-1.on.aws/'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
